export enum EnumTextBoxType {
  Text = 1,
  Number = 2,
  Password = 3,
  Search = 4,
}

